import React from 'react';
import { Box, Typography } from '@mui/material';
import ProdutoVisualizar from '../components/produto/ProdutoVisualizar';

const ProdutoVisualizarPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Visualizar Produto
      </Typography>
      <ProdutoVisualizar />
    </Box>
  );
};

export default ProdutoVisualizarPage;
